import { createApiRef } from '@backstage/core-plugin-api';
import type { RespostaDados } from '../types';

export interface GestaoFluxoApi {
  /** Busca as atividades e a cobertura do banco deste deploy. */
  buscarDados(): Promise<RespostaDados>;
}

export const gestaoFluxoApiRef = createApiRef<GestaoFluxoApi>({
  id: 'plugin.gestao-fluxo.service',
});
